export const ChangeWorkstation = 'can change workstation';
